import { getYear } from 'date-fns';

import type { EstateAnalysis } from './analytics';

type SocioEconomicData = NonNullable<EstateAnalysis['socioEconomics']>[number]['data'];

export const useSocioEconomics = (
  estateAnalysis: EstateAnalysis
): {
  currentYear: number;
  data: Record<string, SocioEconomicData>;
} => {
  const currentDate = new Date();
  const currentYear = getYear(currentDate);

  const data = Object.values(estateAnalysis.socioEconomics).reduce<
    Record<string, SocioEconomicData>
  >((acc, dt) => {
    if (typeof dt === 'object') {
      acc[dt.data.type] = (dt.data as unknown as { data: SocioEconomicData }).data;
    }
    return acc;
  }, {});

  return { currentYear, data };
};
